<template>
  <div class="card mb-4">
    <div class="card-header">
      <h2>Nodig iemand uit</h2>
    </div>
    <div class="card-body">
      <p>Ook enthousiast over Socialtens? Verstuur een uitnodiging naar een bekende, en ontvang
        <strong>€ 40,-</strong> voor iedere actieve deelnemer die je aanbrengt!</p>
      <p class="small">De uitnodiging bevat een unieke code die gebruikt moet worden bij de registratie.</p>

      <form method="post" @submit.prevent="submit">
        <div class="form-group">
          <input type="email" class="form-control" v-model="email"
                 placeholder="E-mailadres" aria-label="E-mailadres">
        </div>
        <button type="submit" class="btn btn-primary">Uitnodigen</button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            email: '',
        };
    },
    methods: {
        submit() {
            let that = this;

            this.axios.post('/reseller/invite', {
                    email: this.email,
                })
                .then(() => {
                    that.$notify({
                        group: 'base',
                        text: `De uitnodiging is verstuurd naar ${this.email}.`,
                        type: 'alert-info',
                    });

                    that.email = '';
                })
                .catch(error => {
                    that.$notify({
                        group: 'base',
                        text: `Er is een fout opgetreden. Mogelijk is de uitnodiging nog niet verstuurd.`,
                        type: 'alert-danger',
                    });
                });
        }
    }
}
</script>




// WEBPACK FOOTER //
// resources/assets/components/ResellerBlock.vue